/**
 * Wrapper rundt fetch for retailer-API-kall.
 * Omdirigerer til innloggingssiden hvis sesjonen har utløpt (401).
 */
export async function retailerFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
    const response = await fetch(input, init);
    if (response.status === 401) {
        window.location.assign("/nexus/");
        throw new Error("Unauthorized");
    }
    return response;
}
